const email = {
  load_failed: '邮件会话加载失败',
  stats_load_failed: '邮件统计加载失败',
  thread_load_failed: '邮件加载失败',
  copied: '已复制 {{address}}',
  platform_fallback: '平台邮箱：{{address}}',
  synced: '已同步 {{count}} 位 Wowbit 带邮箱达人',
  marked_read: '已标为已读',
  mark_read_failed: '标为已读失败',
  talent_detail: '查看达人详情',
  unread_count: '未读 {{count}}',
  sent_count: '发出 {{count}}',
  received_count: '收到 {{count}}',
  opened_count: '打开 {{count}}',
  intent_talent: '意向达人',
  bounced: '退信',
  title: '邮箱',
  platform_email: '平台邮箱',
  forward_hint: '回信同步转发至 {{address}}',
  domain_hint: '达人回信自动进入此邮箱，不可更改发信域名',
  sent_month: '本月已发',
  quota_hint: '/ {{limit}} · 送达率 {{rate}}% · 剩余 {{remain}} 封',
  unread: '未读',
  unread_threads: '{{count}} 个达人会话',
  pending: '待回复',
  pending_hint: '达人已回，待我方回复 · 意向达人 {{count}}',
  pending_reply_hint: '达人已回，待商家回复',
  pending_reply_failed: '待回复邮件数量加载失败',
  new_send: '新建发送',
  sync_talents: '同步 Wowbit 带邮箱达人',
  change_bind: '更换绑定邮箱',
  bind_mine: '绑定我的邮箱',
  copy_platform: '复制平台邮箱',
  conversations: '达人邮件会话',
  sent_received: '发出 {{sent}} · 收到 {{received}}',
  no_match: '没有匹配的会话',
  empty_conversations: '暂无邮件会话',
  reply_placeholder: '回复 {{name}}…',
  reply: '回复',
  reply_sent: '已回复',
  reply_failed: '邮件回复失败',
  mark_read: '标为已读',
  idle: '选择左侧达人查看邮件往来',
  empty_thread: '还没有邮件往来',
  opened: '已打开',
  filter_all: '全部',
  status_WAITING_CREATOR: '等待达人',
  status_NEED_REPLY: '待回复',
  status_PROCESSED: '已处理',
  status_HARD_BOUNCE: '硬退',
  conversation_total: '共 {{total}} 个会话',
  shop_required: '请先选择店铺',
  search_placeholder: '搜索达人 / 邮箱',
  intent: '意向',
  replied: '已回复',
  follow_up: '待跟进',
  tpl_sample: '新品试样合作',
  tpl_repurchase: '复购合作邀请',
  tpl_blank: '空白邮件',
  fill_subject: '请填写邮件主题和正文',
  sent_skipped: '已发送 {{sent}} 封，跳过 {{skipped}} 位（无邮箱 / 退信）',
  sent_ok: '已发送 {{sent}} 封邮件',
  send_failed: '发送失败，请稍后重试',
  recipients: '选择收件达人',
  selected_skip: '已选 {{count}} 位达人，无邮箱 / 已退信的达人将自动跳过',
  invalid_address: '请输入有效的邮箱地址',
  bound: '已绑定 {{address}}，达人回信将同步转发到该邮箱',
  bind: '绑定',
  bind_hint: '绑定后达人回信会同步转发到该邮箱；发信仍使用平台邮箱，以保证送达率与回信归集。',
  blocked_bounced: '该邮箱已退信（地址不可达），请更新达人邮箱后再发送',
  blocked_quota: '本月发信额度已用完（{{limit}} 封）'
};

export default email;
